module.exports = {
	"base": {
		"welcome": "Bienvenue sur Mulligans, %{name} !",
		"user": "Infos utilisateurs",
		"devices": "Appareils",
		"refunds": "Remboursements",
		"resources": "Ressources",
		"transactions": "Commandes et retours",
		"email": "Courriel",
		"password": "Mot de passe",
		"save": "Enregistrer",
		"sign-out": "Se déconnecter",
		"cancel": "Annuler",
		"close": "Fermer",
		"learn-more": "En savoir plus",
		"required": "Requis",
		"support": "Support",
		"bookshelf": "Bookshelf",
		"launch": "Lancement",
		"download": "Télécharger",
		"details": "Détails",
		"cannot-be-blank": "%{field} ne peut pas être vide",
		"saving": "Sauvegarde en cours…",
		"done": "Terminé",
		"failed": "Echec",
		"copy": "Copier"
	},
	"signin": {
		"login-failure": "Votre mot de passe ou votre e-mail est incorrect",
		"welcome-large": "Bienvenue dans l'Account Center <span class='inner'>%{brand}</span>",
		"welcome-small": "<span class='inner'>Account Center</span>",
		"signin-button": "Se connecter",
		"forgot-password": "Vous avez oublié votre mot de passe ?",
		"new-to-vst": "Vous découvrez %{brand} ?",
		"create-account": " Créer un compte",
		"signing-in": "Connexion...",
		"signin-failed": "Échec de la connexion"
	},
	"transactions": {
		"price": "Prix",
		"excluded": "(Hors taxes)",
		"quantity": "Quantité",
		"confirmation#": "Nº de confirmation",
		"payment": "Paiement",
		"purchased": "Acheté",
		"purchase-details": "Informations de l'achat",
		"subtotal": "Sous-Total",
		"total": "Total",
		"tax": "Taxe",
		"loading": "Nous chargeons vos transactions, petit dépensier...",
		"no-purchases": "Aucun achat trouvé.",
		"seller-vat": "TVA vendeur",
		"total-vat": "%{vat} totale payée",
		"portion": "%{subTax} Taxes %{rate}%",
		"vat-disclosure": "Le prix comprend %{vat}",
		"purchases": "Achats",
		"refunded-items": "Articles remboursés",
		"book-title": "Titre du livre",
		"refund-details": "Informations de remboursement",
		"print-receipt": "Imprimer le reçu",
		"request-refund": "Demande de remboursement",
		"expired": "Arrivé à expiration",
		"expires-in": "Expire le %{date}",
		"details-refund": "Détails et remboursement",
		"modal": {
			"cant-refund-title": "Remboursement non disponible",
			"cant-refund": "Votre livre ne peut pas être remboursé pour une ou plusieurs des raisons qui suivent.",
			"cant-refund-1": "Une trop grande quantité de livre a été lue.",
			"cant-refund-2": "Plus de 14 jours se sont écoulés depuis la date d'achat.",
			"cant-refund-3": "Votre code de ressources en ligne a été révélé.",
			"cant-refund-4": "Votre livre a déjà été remboursé.",
			"cant-refund-5": "Tous les codes ont déjà été utilisés et/ou remboursés",
			"cant-refund-6": "Plus de 30 jours se sont écoulés depuis la date d'achat.",
			"cant-refund-support": "Si vous avez toujours des questions sur la politique de remboursement de %{brand}, contactez <a href='%{support_url}' target='_blank'>le service d'assistance</a>."
		},
		"license": {
			"perpetual": "L'accès en ligne n'expirera pas",
			"days": "%{days} Accès journalier"
		}
	},
	"devices": {
		"description": "%{brand} vous permet d'activer les ordinateurs <span>%{desktop}</span> et appareils mobiles/tablettes <span>%{mobile}</span> à tout moment.",
		"loading": "Nous enregistrons vos appareils",
		"no-active": "Vous ne disposez d'aucun appareil actif.",
		"deactivate": "Désactiver"
	},
	"user": {
		"personal-information": "Informations personnelles",
		"security-information": "Données de sécurité",
		"notifications": "Notifications",
		"first-name": "Prénom",
		"last-name": "Nom",
		"change-password-title": "Modifier le mot de passe",
		"current-password": "Mot de passe actuel",
		"new-password": "Nouveau mot de passe",
		"security-password": "Mot de passe",
		"confirm-new-password": "Confirmation du nouveau mot de passe",
		"security-question": "Question de sécurité",
		"security-info-change": "Modifier",
		"question": "Question",
		"answer": "Réponse",
		"notifications-text": "Envoyez-moi les mises à jour occasionnelles sur l'activité de mon compte, les mises à jour de produits et les offres spéciales.",
		"loading": "Spot recherche vos informations utilisateur, un instant 🐶",
		"change-password-text": "Votre mot de passe doit contenir au moins 8 caractères, une lettre majuscule, une lettre minuscule et un caractère spécial.",
		"email-locked": "E-mail verrouillé",
		"email-locked-description": "Vous n'avez pas accès pour changer votre adresse e-mail.",
		"email-locked-more": "Veuillez contacter votre administrateur.",
		"security-question6": "Quel est votre sport préféré ?",
		"security-question7": "Quelle est votre glace préférée ?",
		"security-question8": "Quel est le nom de votre animal préféré ?",
		"security-question9": "Quand vous étiez petit, vous vouliez être...?",
		"security-question10": "Quel était le nom de famille votre professeur préféré ?",
		"new-password-failure": "Le mot de passe ne répond pas aux conditions",
		"confirm-password-failure": "Le mot de passe doit correspondre",
		"new-password-tooltip": "Doit contenir au moins 8 caractères, une lettre majuscule, une lettre minuscule et un caractère spécial.",
		"enter-valid-email": "Veuillez saisir une adresse mail valide.",
		"password-cannot-be-same": "Votre mot de passe actuel et votre mot de passe précédent ne peuvent pas être identiques",
		"incorrect-password": "Mot de passe incorrect",
		"complete-account": "On dirait que vous avez besoin de <a href='%{href}'>compléter votre compte</a>.",
		"completing-allows": "Votre compte vous permet de lire des livres en mode hors connexion sur nos applications mobiles et de partager des notes et des surlignes avec des amis.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Annexes",
		"access-codes": "Codes d'accès",
		"print-on-demand": "Impression à la demande",
		"check-pod": "Consultez les options d'impression éditeur pour vos livres.",
		"check-now": "Vérifier maintenant",
		"loading": "Veuillez patienter, nous mettons vos ressources à jour !",
		"in": "dans",
		"access-code-intro": "Un code d'accès est un mot de passe que vous utilisez pour accéder au contenu de vos cours en ligne. Une fois que vous affichez le code d'un article, vous ne serez pas en mesure de le rendre. Pour plus d'instructions sur l'utilisation de votre code d'accès, veuillez contacter <a href='%{support_url}' target='_blank'>le centre d'assistance</a>.",
		"expires": "Arrive à expiration",
		"expiration-message": "Contient des instructions d'utilisation pour votre code d'accès.",
		"copy-fail": "Copie impossible. Veuillez sélectionner le code et copiez-le manuellement.",
		"launch-site": "Ouvrir le site",
		"launch-book": "Ouvrir le livre",
		"reveal-code": "Afficher le code",
		"no-resources": "Vous n'avez aucune ressources.",
		"no-access-codes": "Vous n'avez aucun code d'accès.",
		"no-ancillaries": "Aucune annexe pour ce titre",
		"name": "Nom",
		"type": "Type",
		"size": "Taille",
		"download-all": "Tout télécharger",
		"back": "Retour aux ressources"
	},
	"refunds": {
		"states": {
			"refunded": "Remboursé",
			"unavailable": "Remboursement non disponible"
		},
		"reasons": {
			"dropped": "J'ai abandonné le cours",
			"wrong": "Ce livre ne correspondait pas à mon cours",
			"print": "Je décidé d'acheter une version imprimée à la place",
			"missing": "Le livre ne contient pas tout ce dont j'ai besoin pour mon cours (un CD, un lien vers la page web, des vidéos)",
			"other": "Autres"
		},
		"bulk": {
			"policy": "En cliquant sur la touche « Effectuer remboursement » ci-dessous, j'accepte la  <a href='%{policy_url}' target='_blank'>politique de remboursement</a> de %{brand}.",
			"complete": "Effectuer remboursement",
			"view-details": "Afficher les détails du remboursement",
			"success": "Vous avez demandé un remboursement. Veuillez patienter 48 heures pour son traitement.",
			"failure": "Oups ! Une erreur s'est produite... Malheureusement, votre remboursement n'a pas été confirmé.",
			"retry": "Essayez à nouveau",
			"support": "Contacter le service technique",
			"available-codes": "Codes disponibles",
			"codes-selected": "Codes sélectionnés",
			"download": "Télécharger codes",
			"partially-refunded": "Partiellement remboursé",
			"pick-one": "Vous devez sélectionner au minimum un code pour effectuer un remboursement"
		},
		"refund": "Remboursement",
		"all": "Tout rembourser ?",
		"missing-reason": "Vous devez sélectionner une raison avant de continuer",
		"missing-elaboration": "Veuillez préciser",
		"policy": "En cliquant sur le bouton « Effectuer une demande de remboursement » ci-dessous, je comprends que si j'achète à nouveau cet eTextbook %{brand}, je ne pourrai pas effectuer une demande de remboursement supplémentaire pour le même eTextbook. Afficher la politique de retour complète.",
		"refunded": "Remboursé",
		"sorry": "Nous sommes désolés d'apprendre que vous n'avez pas été satisfait(e) de votre achat.",
		"error": "Une erreur s'est produite. ",
		"error-explain": "Nous n'avons pas pu traiter votre remboursement. Veuillez réessayer.",
		"why": "Dites-nous pourquoi ?",
		"no-refunds": "Aucun article remboursé.",
		"select-codes": "Sélectionnez un(des) code(s) à rembourser :",
		"number": "Combien ?",
		"back": "Retour aux remboursements"
	},
	"purchases": {
		"back": "Retour aux achats"
	},
	"global-bar": {
		"account": "Paramètres du compte"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/fr.json
 ** module id = 1008
 ** module chunks = 0
 **/